import { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router'
import ArrowBack from '../../../components/ArrowBack'
import { api } from '../../../services/api'
import { Container } from './styles'

const CategoriesShow = () => {

    let { id } = useParams()
    const [category, setCategory] = useState({})

    const loadCategory = async () => {
        const response = await api.get(`categories/show/${id}`)
        setCategory(response.data)
        console.log(response.data)
    }

    useEffect(() => {
        loadCategory()
    }, [])

    return (
        <Container>
            <ArrowBack className='voltar' />
            <h1>{category?.name}</h1>
            <p>{category?.description}</p>
        </Container>
    )
}

export default CategoriesShow
